import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const unichainSepolia: VToken[] = [
  {
    chainId: 1301,
    address: "0x7d39496Ac9FdA5a336CB2A96FD5Eaa022Fd6Fb05",
    decimals: 8,
    symbol: "vcbBTC_Core",
    underlyingToken: tokens[1301][2]!,
  },
  {
    chainId: 1301,
    address: "0x3dEAcBe87e4B6333140a46aBFD12215f4130B132",
    decimals: 8,
    symbol: "vWETH_Core",
    underlyingToken: tokens[1301][1]!,
  },
  {
    chainId: 1301,
    address: "0x0CA7edfcCF5dbf8AFdeAFB2D918409d439E3320A",
    decimals: 8,
    symbol: "vUSDC_Core",
    underlyingToken: tokens[1301][3]!,
  },
  {
    chainId: 1301,
    address: "0x2d8814e1358D71B6B271295893F7409E3127CBBf",
    decimals: 8,
    symbol: "vUSDT_Core",
    underlyingToken: tokens[1301][4]!,
  },
  {
    chainId: 1301,
    address: "0xaE43aAd383b93FCeE5d3e0dD2d40b6e94639c642",
    decimals: 8,
    symbol: "vUNI_Core",
    underlyingToken: tokens[1301][6]!,
  },
  {
    chainId: 1301,
    address: "0xF46F0E1Fe165018EC778e0c61a71661f55aEa09B",
    decimals: 8,
    symbol: "vweETH_Core",
    underlyingToken: tokens[1301][7]!,
  },
  {
    chainId: 1301,
    address: "0xb24c9a851542B4599Eb6C1644ce2e245074c885f",
    decimals: 8,
    symbol: "vwstETH_Core",
    underlyingToken: tokens[1301][8]!,
  },
  {
    chainId: 1301,
    address: "0x3aaa754E66fcACd84b01Ae5493c922AF8D4E77c7",
    decimals: 8,
    symbol: "vWBTC_Core",
    underlyingToken: tokens[1301][10]!,
  },
  {
    chainId: 1301,
    address: "0x02A5E844C4B0FF5a587B4EE239BEe7c479530447",
    decimals: 8,
    symbol: "vUSD₮0_Core",
    underlyingToken: tokens[1301][9]!,
  },
];
